module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 131
// module chunks = 221